import StoreTransferList from './StoreTransferList';
export type {StoreTransferListProps} from './StoreTransferList';
export default StoreTransferList;
